<template>
	<div>
		<div class="login-main-sub-container position-relative">
			<div
				class="w-100 d-flex justify-content-center align-items-baseline mb-3"
			>
				<img
					src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Logo/SVG/Hire3x_Website_Header.svg"
					style="
						display: block;
						visibility: visible;
						opacity: 1;
						height: 40px;
					"
					alt=""
				/>
			</div>
			<div
				class="d-flex align-items-center flex-column text-center internetcheck-page-container"
			>
				<embed
					style="display: none"
					id="pdfEmbed"
					src="../../assets/check-upload-speed.pdf"
					width="100%"
					height="500px"
					type="application/pdf"
				/>
				<div class="internetcheck-content-wrapper d-flex h-100 flex-column justify-content-center align-items-center">
					<h1 v-if="!bothFetched" class="fw-500 check-speed-heading">
						Checking your Internet Speed
					</h1>
					<div class="w-100">
						<div
							class="d-flex align-items-center justify-content-around flex-column mt-4 w-100"
						>
							<div
								v-if="!bothFetched"
								class="intspd-cardcontainer intspd-meter-container d-flex flex-column align-items-center justify-content-center p-4"
							>
								<div class="i-guage position-relative mt-4 mb-4">
									<div class="i-guage__body">
										<div class="i-guage__fill"></div>
										<div class="i-guage__cover">
											<img
												:style="`transform: rotate(${angleValue}deg)`"
												class="speedometer-origin"
												id="speed-img"
												src="../../assets/newimgs/speedometerArrow.svg"
												alt=""
											/>
										</div>
									</div>
									<div
										class="position-absolute speedometer-txt"
										style="left: -26px; bottom: -5px"
									>
										0
									</div>
									<div
										class="position-absolute speedometer-txt"
										style="left: -10px; bottom: 47px"
									>
										10
									</div>
									<div
										class="position-absolute speedometer-txt"
										style="top: -20px; left: 26px"
									>
										30
									</div>
									<div
										class="position-absolute speedometer-txt"
										style="top: -37px; right: 84px"
									>
										50
									</div>
									<div
										class="position-absolute speedometer-txt"
										style="top: -20px; right: 18px"
									>
										70
									</div>
									<div
										class="position-absolute speedometer-txt"
										style="right: -18px; bottom: 46px"
									>
										90
									</div>
									<div
										class="position-absolute speedometer-txt"
										style="right: -52px; bottom: -5px"
									>
										100+
									</div>
								</div>
							</div>
							<div
								v-else
								class="intspd-cardcontainer d-flex flex-column align-items-center justify-content-center p-4"
							>
								<div
									class="intspd-main-text d-flex align-items-center justify-content-center"
								>
									<div
										v-if="isNetSpeed"
										class="d-flex align-items-center justify-content-center flex-column"
									>
										<img
											src="../../assets/newui-img/icstable.svg"
											alt=""
											class="my-1"
										/>
										Your internet speed is stable.
										<br />
										Click "Next" to proceed with the test
									</div>
									<div
										v-else
										class="d-flex align-items-center justify-content-center flex-column"
									>
										<img
											src="../../assets/newui-img/warning.svg"
											alt=""
											class="my-1"
										/>
										Due to a slow internet connection, the test
										<br />
										cannot be taken.
									</div>
								</div>
								<div
									v-if="bothFetched"
									class="mt-5 d-flex align-items-center justify-content-center bluebtns"
								>
									<b-button
										v-if="isNetSpeed"
										@click="next()"
										class="w-100px candash-addBtn"
										variant="primary"
										>Next</b-button
									>
									<b-button
										@click="resetAllValues"
										v-else
										class="w-100px candash-addBtn"
										variant="primary"
										>Retry</b-button
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import internet from "../../mixins/internet";
export default {
	name: "MobileNewInternetCheck",
	mixins: [internet],
};
</script>

<style scoped>
/* Stylings are inherited from the global styles defined in InternetSpeed.vue */
</style>
